// extracted by mini-css-extract-plugin
export var formContainer = "_jd-0";
export var message = "_jd-1";